import "@/App.css";
import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import Layout from "@/components/Layout";
import { BASENAME, LANG } from "@/lib/lang";

if (typeof document !== "undefined") {
  document.documentElement.lang = LANG;
  // Greek site uses a single typeface (Google Sans, with Greek glyphs).
  // Loaded only for /el so the English site's fonts/perf stay unchanged.
  if (LANG === "el") {
    document.documentElement.classList.add("lang-el");
    const gsFont = document.createElement("link");
    gsFont.rel = "stylesheet";
    gsFont.href = "https://fonts.googleapis.com/css2?family=Google+Sans:wght@300;400;500;600;700&display=swap";
    document.head.appendChild(gsFont);
  }
}

// Route-based code splitting: each page ships its own JS chunk,
// so a visitor only downloads the page they land on.
const Home = lazy(() => import("@/pages/Home"));
const About = lazy(() => import("@/pages/About"));
const ApartmentDetail = lazy(() => import("@/pages/ApartmentDetail"));
const DiscoverMilos = lazy(() => import("@/pages/DiscoverMilos"));
const Guides = lazy(() => import("@/pages/Guides"));
const GuideDetail = lazy(() => import("@/pages/GuideDetail"));
const Gallery = lazy(() => import("@/pages/Gallery"));
const Contact = lazy(() => import("@/pages/Contact"));
const Policy = lazy(() => import("@/pages/Policy"));
const BookingPolicy = lazy(() => import("@/pages/BookingPolicy"));

// Preserve original Webflow URLs by redirecting them to the new routes.
const ToApartment = () => {
  const { slug } = useParams();
  return <Navigate to={`/apartments/${slug}`} replace />;
};
const ToGuide = () => {
  const { slug } = useParams();
  return <Navigate to={`/guides/${slug}`} replace />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter basename={BASENAME}>
        <Suspense fallback={<div className="min-h-screen bg-sand" />}>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="about" element={<About />} />
              <Route path="apartments/:slug" element={<ApartmentDetail />} />
              <Route path="discover-milos" element={<DiscoverMilos />} />
              <Route path="guides" element={<Guides />} />
              <Route path="guides/:slug" element={<GuideDetail />} />
              <Route path="gallery" element={<Gallery />} />
              <Route path="contact" element={<Contact />} />
              <Route path="policy" element={<Policy />} />
              <Route path="booking-policy" element={<BookingPolicy />} />

              {/* Legacy Webflow paths */}
              <Route path="old-home" element={<Navigate to="/" replace />} />
              <Route path="all-apartment" element={<Navigate to="/" replace />} />
              <Route path="all-guides" element={<Navigate to="/guides" replace />} />
              <Route path="apartment-details/:slug" element={<ToApartment />} />
              <Route path="guide-blog-posts/:slug" element={<ToGuide />} />

              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
}

export default App;
